import { z } from 'zod';
import { validateState } from '../ValidateState.ts';
import { fogTileGroupStatesPartialSchema, fogTileGroupStatesSchema } from './FogTileGroupState.ts';
import { portEdgeStatesPartialSchema, portEdgeStatesSchema } from './PortEdgeState.ts';
import { tileCornerStatesPartialSchema, tileCornerStatesSchema } from './TileCornerState.ts';
import { tileEdgeStatesPartialSchema, tileEdgeStatesSchema } from './TileEdgeState.ts';
import { tileHexStatesPartialSchema, tileHexStatesSchema } from './TileHexState.ts';
import { AT_LEAST_ONE_PROPERTY_MESSAGE } from '../PartialStrictObjectSchema.ts';
export const mapStateSchema = z.object({
    tileHexStates: tileHexStatesSchema.readonly(),
    tileCornerStates: tileCornerStatesSchema.readonly(),
    tileEdgeStates: tileEdgeStatesSchema.readonly(),
    portEdgeStates: portEdgeStatesSchema.readonly(),
    fogTileGroupStates: fogTileGroupStatesSchema.exactOptional()
}).strict();
export function validateMapState(data) {
    return validateState(mapStateSchema, data);
}
export const mapStatePartialSchema = z.object({
    tileHexStates: tileHexStatesPartialSchema.readonly(),
    tileCornerStates: tileCornerStatesPartialSchema.readonly(),
    tileEdgeStates: tileEdgeStatesPartialSchema.readonly(),
    portEdgeStates: portEdgeStatesPartialSchema.readonly(),
    fogTileGroupStates: fogTileGroupStatesPartialSchema
}).partial().strict().refine((obj)=>Object.keys(obj).length > 0, {
    message: AT_LEAST_ONE_PROPERTY_MESSAGE
});
export function validateMapStatePartial(data) {
    return validateState(mapStatePartialSchema, data);
}
